import React, { useState, useEffect } from "react";

function Address() {
   const [isLargeScreen, setIsLargeScreen] = useState(() =>
      window.matchMedia("(min-width: 1280px)").matches
    );
     useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1280px)");
        const handleChange = (e) => setIsLargeScreen(e.matches);
        mediaQuery.addEventListener("change", handleChange);
    
        return () => {
          mediaQuery.removeEventListener("change", handleChange);
        };
      }, []);
  return (
         <>
         {isLargeScreen&&
          <div className="parent-container upx-14 m-0 uh-150 d-flex bg-gray-light align-items-center">
          <div className="uh-120 uw-170 text-start">
          <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.107180360531!2d79.04849580000001!3d21.108292700000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf8f88bb6523%3A0xdc3059d8bb7636f4!2sRaycura%20Medical%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1737530531194!5m2!1sen!2sin"
          className="uw-140 uh-120 br-5 box-shadow m-0 p-0"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>  
          </div>
          <div className="uh-120 upt-7 m-0 upx-10 uw-140 text-gray bg-gray-light box-shadow br-5 ">
            <p className="heading1 fw-bold ufs-6 m-0 upt-7 "><span style={{color:"#33b3a6"}} >Address</span><br></br>Renuka apartment, Plot no 79/80 Flat no 202, Swavalambi Nagar, Nagpur, Maharashtra 440022</p>
            <p className="heading2 fw-bold ufs-6 m-0 upt-7   "><span style={{color:"#33b3a6"}} >CIN </span><br></br>U33309MH2021PTC353794</p>
            <p className="heading2 fw-bold ufs-6 m-0 upt-7 "><span style={{color:"#33b3a6"}} >Contact for Enquries </span><br></br>Mobile No :7028264636 <br></br>Mail : mail@raycura.com</p>
            
          </div>
        </div>  
         
         }{!isLargeScreen&&
          <div className=" upx-14 mb-3 w-100  bg-gray-light ">
            <div className="uh-250 w-100 my-4 text-start">
            <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.107180360531!2d79.04849580000001!3d21.108292700000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf8f88bb6523%3A0xdc3059d8bb7636f4!2sRaycura%20Medical%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1737530531194!5m2!1sen!2sin"
            className="uh-250 w-100 br-20 box-shadow m-0 p-0"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          ></iframe>  
            </div>
            <div className=" w-100 py-4 m-0 px-4  text-gray bg-gray-light box-shadow br-20 ">
              <p className="heading1 fw-bold ufs-14 m-0 upt-7 "><span style={{color:"#33b3a6"}} >Address</span><br></br>Renuka apartment, Plot no 79/80 Flat no 202, Swavalambi Nagar, Nagpur, Maharashtra 440022</p>
              <p className="heading2 fw-bold ufs-14 m-0 upt-7   "><span style={{color:"#33b3a6"}} >CIN </span><br></br>U33309MH2021PTC353794</p>
              <p className="heading2 fw-bold ufs-14 m-0 upt-7 "><span style={{color:"#33b3a6"}} >Contact for Enquries </span><br></br>Mobile No :7028264636 <br></br>Mail : mail@raycura.com</p>
              
            </div>
          </div>  
         }
         
         </>
        
  );
}

export default Address;